import React from 'react';
import './Contact.css';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import contactVector from './../../assets/contact_anime.png';
import { socialLink } from '../../../src/profile';

function Contact() {
  return (
    <div className="section-container fade-in">
      <Header
        heading="Get in touch."
        details="Interested to collaborate? Feel free to drop me an email."
      />

      <div className="contact-main-content">
        {/* Contact Form Wrapper */}
        <div className="contact-card glass-card">
          <form 
            className="contact-form" 
            action="https://formspree.io/f/mvolyzwg"
            method="POST"
          >
            <div className="form-group">
              <label htmlFor="email" className="form-label">Email Address</label>
              <input
                id="email"
                type="email"
                placeholder="you@example.com"
                name="email"
                className="contact-input-box"
                autoComplete="off"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="message" className="form-label">Your Message</label>
              <textarea
                id="message"
                placeholder="Tell me about your project or what's on your mind..."
                name="message"
                className="contact-textarea-box"
                required
              ></textarea>
            </div>

            <button type="submit" className="contact-submit-btn">
              Send Message &rarr;
            </button>
          </form>
        </div>

        {/* Social Dock */}
        <div className="social-links-dock glass-card">
          <p className="social-dock-title">Find me on other networks</p>
          <div className="social-icons-row">
            {socialLink.map(({ name, url, link }) => (
              <a 
                key={name}
                href={url} 
                className={`social-icon-btn ${name.toLowerCase()}`}
                target="_blank" 
                rel="noopener noreferrer"
                title={`Connect on ${name}`}
              >
                <img src={link} alt={name} className="social-icon-img" />
              </a>
            ))}
          </div>
        </div>
      </div>

      <Footer
        title="Check out my 👉 "
        link="My Personal Project!"
        toAdress="/personal-projects"
      />

      {/* Background vector (soft opacity decoration) */}
      <div className="vector-frame">
        <img
          src={contactVector}
          alt=""
          className="about-vector"
        />
      </div>
    </div>
  );
}

export default Contact;
